import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@guildeducationinc/recess';
import { useClients } from '@src/hooks/useClients';
import { useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
import styles from './ClientPicker.module.scss';
export const ClientPicker = ({ clientId, onChange, disabled = false, }) => {
    const { clients, error } = useClients({ initialPageSize: 100 });
    const { t } = useLocale();
    const options = useMemo(() => {
        return clients.map(client => ({
            value: client.id.toString(),
            label: client.name,
        }));
    }, [clients]);
    const handleChange = (e) => {
        const value = e.selection?.value;
        if (value) {
            onChange(parseInt(value));
        }
        else {
            onChange(undefined);
        }
    };
    return (_jsx(Select, { easyPortal: true, className: styles.clientPicker, label: t('Employer'), options: options, value: (clientId || '').toString(), onChange: handleChange, errors: error?.message, disabled: disabled }));
};
